import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
//import ImageUpload from "../../components/imageUpload.js";

const InvoicepaymentEdit = () => {
  const [paymentdate, setPaymentdate] = useState("");
  const [client, setClient] = useState("");
  const [invoiceid, setInvoiceid] = useState("");
  const [invoiceno, setInvoiceno] = useState("");
  const [amount, setAmount] = useState("");
  const [receiptno, setReceiptno] = useState("");
  const [redirect, setRedirect] = useState(false);
  const ref = useRef < HTMLInputElement > null;

  let { id } = useParams();
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`invoicepayment/${id}`);
      setPaymentdate(data.paymentdate);
      setClient(data.client);
      setInvoiceid(data.invoiceid);
      setInvoiceno(data.invoiceno);
      setAmount(data.amount);
      setReceiptno(data.receiptno);
    })();
  }, [id]);
  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.put(`invoicepayment/${id}`, {
      paymentdate,
      client,
      invoiceid,
      invoiceno,
      amount,
      receiptno,
    });
    console.log(data);
    setRedirect(true);
  };
  //   const updateImage = (url) => {
  //     if (ref.current) {
  //       ref.current.value = url;
  //     }
  //     setLogoImage(url);
  //   };
  if (redirect) {
    return <Navigate to={"/invoicepayment"} />;
  }
  return (
    <Wrapper pageTitle={"Edit Invoicepayment"}>
      <InnerNav
        createLink={"/invoicepaymentCreate"}
        listLink={"/invoicepayment"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Paymentdate{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Paymentdate"
              value={paymentdate}
              onChange={(e) => setPaymentdate(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Client </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Client"
              value={client}
              onChange={(e) => setClient(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Invoiceid </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Invoiceid"
              value={invoiceid}
              onChange={(e) => setInvoiceid(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Invoiceno </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Invoiceno"
              value={invoiceno}
              onChange={(e) => setInvoiceno(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Amount </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Receiptno </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Receiptno"
              value={receiptno}
              onChange={(e) => setReceiptno(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default InvoicepaymentEdit;
